import {IPrefetchDestinationsParams} from "../../../../shared/interfaces/iprefetch-destinations-params";

export function createPrefetchParams(onlyCustomHoliday, onlyNetQuote, ages) : IPrefetchDestinationsParams{
  return {
    onlyCustomHoliday: onlyCustomHoliday,
    onlyNetQuotes: onlyNetQuote,
    ages: ages,
  }
}
